import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Anchor from "../elements/Anchor";

const Footer = ({ footer_menu }) => {
  return (
    <footer className="mt-5">
      <Container>
        <Row className="footer-wraper">
          <Col lg={4} className="mb-5">
            <Anchor
              href={footer_menu[0].link.url}
              target={footer_menu[0].link.target}
              title={footer_menu[0].label}
              className="footer-address link-underline-hover"
            >
              {footer_menu[0].label}
            </Anchor>
          </Col>

          <Col lg={5} className="d-flex flex-column mb-5">
            <Anchor
              href={footer_menu[3].link.url}
              target={footer_menu[3].link.target}
              title={footer_menu[3].label}
              className="mb-2 link-underline-hover"
            >
              {footer_menu[3].label}
            </Anchor>
            <Anchor
              href={footer_menu[4].link.url}
              target={footer_menu[4].link.target}
              title={footer_menu[4].label}
              className="link-underline-hover"
            >
              {footer_menu[4].label}
            </Anchor>
          </Col>
          <Col lg={3} className="mb-5 d-flex flex-column">
            <Anchor
              href={footer_menu[1].link.url}
              target={footer_menu[1].link.target}
              title={footer_menu[1].label}
              className="mb-2 link-underline-hover"
            >
              {footer_menu[1].label}
            </Anchor>
            <Anchor
              href={footer_menu[2].link.url}
              target={footer_menu[2].link.target}
              title={footer_menu[2].label}
              className="link-underline-hover"
            >
              {footer_menu[2].label}
            </Anchor>
          </Col>
          <Col lg={4} className="mb-5">
            <Anchor
              href={footer_menu[5].link.url}
              target={footer_menu[5].link.target}
              title={footer_menu[5].label}
              className="link-underline-hover"
            >
              {footer_menu[5].label}
            </Anchor>
          </Col>
          <Col lg={5} className="mb-5 d-flex flex-column">
            <span>Copyright © 2022</span>
            <span>Kokkinou - Kourkoulas</span>
            <span>All Rights Reserved</span>
          </Col>
          <Col lg={3} className="mb-5">
            <Anchor
              href="https://think-plus.gr/"
              target="_blank"
              className="d-flex flex-column link-underline-hover"
            >
              <span>Web Design</span>
              <span>& Development</span>
              <span>by Τhink Plus</span>
            </Anchor>
          </Col>
        </Row>
      </Container>
      <div className="d-flex px-sm-5">
        <div className="footer-bottom bg-primary w-75" />
        <div className="footer-bottom bg-secondary w-25" />
      </div>
    </footer>
  );
};

export default Footer;
